import useGetPage from './useGetPage';

export default useGetPage;
